import { FaTimes } from "react-icons/fa";

function QuestionItem({ question, newQuestions, setNewQuestions }) {
    const removeQuestion = (id) => {
        setNewQuestions(newQuestions.filter((q) => q.id !== id));
    };

    return (
        <div
            style={{
                // width: "100%",
                maxWidth: "400px",
                flexGrow: 1,
                borderRadius: "0.5vh",
                overflow: "hidden",
                border: "1px solid #fbbf24",
                padding: "1vh",
                backgroundColor: "#2a2416",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "row",
                position: "relative",
                transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#fbbf24";
                e.currentTarget.style.backgroundColor = "#3a2f1a";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#fbbf24";
                e.currentTarget.style.backgroundColor = "#2a2416";
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: "0.5vh",
                        gap: "0.5vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#fbbf24",
                            textTransform: "uppercase",
                        }}
                    >
                        Bonusspørsmål
                    </div>
                </div>
                <div
                    style={{
                        fontSize: 14,
                        color: "white",
                        textAlign: "left",
                    }}
                >
                    {question.question}
                </div>
            </div>
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    removeQuestion(question.id);
                }}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "1vh",
                    flexShrink: 0,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#dc2626";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                }}
            >
                <FaTimes color="#9ca3af" size={12} />
            </div>
        </div>
    );
}

export default QuestionItem;
